/**
 * Cycling Text shared block scripts
 * This file gets shared between the
 * theme and editor.
 */

const cycles = document.querySelectorAll('.js-cycle')
cycles?.forEach((cycle) => {
	const texts = cycle.textContent?.split(`\n`)
	const num = texts.length
	if (num) {
		let index = 0
		cycle.innerHTML = `<div>${texts.join('</div><div>')}</div>`
		const lines = cycle.querySelectorAll('div')
		const underline = cycle.nextSibling
		const cycleText = () => {
			lines.forEach((line, i) => {
				line.classList.remove('active')
				if (i === index) {
					cycle.dataset.curCycle = index
					line.classList.add('active')
					underline.style.width = `${line.offsetWidth}px`
				}
			})
			index = index < num - 1 ? index + 1 : 0
		}
		cycleText()
		setInterval(() => {
			cycleText()
		}, cycle.dataset.speed)
	}
})
